.hidden{opacity:0}.button-content-wrapper{position:relative}.button-progress{position:absolute;top:25%;left:calc(50% - 8px);transform:translate(-25%,calc(-50% + 8px));z-index:999}
/*# sourceMappingURL=progress-button.component-UDACQB7D.css.map */
